module.exports = {"360426100":"蒲亭镇","360426101":"聂桥镇","360426102":"车桥镇","360426103":"丰林镇","360426104":"吴山镇","360426200":"宝塔乡","360426201":"河东乡","360426202":"高塘乡","360426203":"林泉乡","360426205":"磨溪乡","360426206":"爱民乡","360426207":"邹桥乡","360426208":"塘山乡","360426500":"彭山林场","360426501":"园艺场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360426.json
// module id = 1384
// module chunks = 0